// Typelizer digest a2cba5ceb7cdce1b5b1f4058d6f67456
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** POST /c/:company_id/ledger/vies_return/filing */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/ledger/vies_return/filing', {}, options),
    method: 'post',
  }),
}
